import { getDefaultDimensionAggregation, getTypeName } from '@rawgraphs/rawgraphs-core'
import get from 'lodash/get'
import uniqueId from 'lodash/uniqueId'
import { getAggregationList } from './aggregationConfig'

/**
 * Creates the mapping record expected by RAWGraphs for a selected data field.
 * Shared by the production mapper and Labs so aggregation configuration never
 * drifts between the two entry points.
 */
export function buildDimensionMappingForColumn(
  previousMapping,
  dimension,
  columnId,
  dataTypes
) {
  const defaultAggregation = dimension.aggregation
    ? getDefaultDimensionAggregation(dimension, dataTypes[columnId])
    : null
  const columnDataType = getTypeName(dataTypes[columnId])
  const isValid =
    dimension.validTypes?.length === 0 ||
    dimension.validTypes?.includes(columnDataType)

  if (dimension.multiple) {
    return {
      ...previousMapping,
      ids: [...(previousMapping.ids || []), uniqueId()],
      value: [...(previousMapping.value || []), columnId],
      isValid,
      mappedType: columnDataType,
      config: dimension.aggregation
        ? {
            aggregation: [
              ...getAggregationList(previousMapping),
              defaultAggregation,
            ],
          }
        : undefined,
    }
  }

  return {
    ...previousMapping,
    ids: [get(previousMapping, 'ids[0]', uniqueId())],
    value: [columnId],
    isValid,
    mappedType: columnDataType,
    config: dimension.aggregation
      ? { aggregation: [defaultAggregation] }
      : undefined,
  }
}
